module.exports = __webpack_public_path__ + "media/public/images/icon-search-dceb3eeff267c23ceaa55d001d261398.png";